import {strings as defaultStrings} from '../../util/strings';

interface ReduxState {
  value: any;
}

export function isAuthenticatedReducer(
  state: ReduxState = {value: false},
  action: any
) {
  switch (action.type) {
    case 'SET_IS_AUTHENTICATED': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function loadingInfoReducer(
  state: ReduxState = {value: false},
  action: any
) {
  switch (action.type) {
    case 'SET_LOADING_INFO': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function purposesReducer(state: ReduxState = {value: []}, action: any) {
  switch (action.type) {
    case 'SET_PURPOSES': {
      return {value: action.value};
    }
    case 'ADD_PURPOSE': {
      return {value: [...state.value, action.value]};
    }
    default:
      return state;
  }
}

export function digitalCommunicationsReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_DIGITAL_COMMUNICATIONS': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function userReducer(state: ReduxState = {value: {}}, action: any) {
  switch (action.type) {
    case 'SET_USER': {
      return {value: {...action.value}};
    }
    case 'ADD_TO_USER': {
      return {value: {...state.value, ...action.value}};
    }
    case 'CHANGE_USER_DOB': {
      return {value: {...state.value, birthdate: action.value}};
    }
    default:
      return state;
  }
}

export function wizardReducer(state: ReduxState = {value: {}}, action: any) {
  switch (action.type) {
    case 'SET_WIZARD': {
      return {value: {...action.value}};
    }
    case 'ADD_TO_WIZARD': {
      return {value: {...state.value, ...action.value}};
    }
    default:
      return state;
  }
}

export function patientsReducer(state: ReduxState = {value: {}}, action: any) {
  switch (action.type) {
    case 'SET_PATIENTS': {
      let card = {cardDetail: action.value.card.cardDetail};
      let newValue = {...action.value, card};
      return {value: {...newValue}};
    }
    default:
      return state;
  }
}

export function globalStylesReducer(
  state: ReduxState = {value: {primaryColor: ''}},
  action: any
) {
  switch (action.type) {
    case 'SET_GLOBAL_STYLES': {
      return {value: {...action.value}};
    }
    case 'ADD_TO_GLOBAL_STYLES': {
      return {value: {...state.value, ...action.value}};
    }
    default:
      return state;
  }
}

export function selectedBuReducer(
  state: ReduxState = {value: {}},
  action: any
) {
  switch (action.type) {
    case 'SET_SELECTED_BU': {
      let card = {cardDetail: action.value.card?.cardDetail};
      let newValue = {...action.value, card};
      return {value: {...newValue}};
    }
    default:
      return state;
  }
}

export function availableBusReducer(
  state: ReduxState = {value: {}},
  action: any
) {
  switch (action.type) {
    case 'SET_AVAILABLE_BUS': {
      return {value: {...action.value}};
    }
    default:
      return state;
  }
}
export function stringsReducer(
  state = {value: {...defaultStrings}},
  action: any
) {
  switch (action.type) {
    case 'SET_STRINGS': {
      return {value: {...action.value}};
    }
    default:
      return state;
  }
}

  export function stringsLoadedReducer(
    state: ReduxState = {value: false},
    action: any
  ) {
    switch (action.type) {
      case 'SET_STRINGS_LOADED': {
        return {value: action.value};
      }
      default:
        return state;
    }
  }

export function busMapReducer(state: ReduxState = {value: null}, action: any) {
  switch (action.type) {
    case 'SET_BUS_MAP': {
      return {value: {...action.value}};
    }
    default:
      return state;
  }
}

export function busStylesMapReducer(
  state: ReduxState = {value: {}},
  action: any
) {
  switch (action.type) {
    case 'SET_BUS_STYLES_MAP': {
      return {value: {...action.value}};
    }
    default:
      return state;
  }
}

export function busFuncMapReducer(
  state: ReduxState = {value: {}},
  action: any
) {
  switch (action.type) {
    case 'SET_BUS_FUNCTIONALITIES_MAP': {
      return {value: {...action.value}};
    }
    default:
      return state;
  }
}

export function busFuncMapDefaultReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_BUS_FUNCTIONALITIES_MAP_DEFAULT': {
      return {value: {...action.value}};
    }
    default:
      return state;
  }
}

export function ibanReducer(state: ReduxState = {value: null}, action: any) {
  switch (action.type) {
    case 'SET_IBAN': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function titularReducer(state: ReduxState = {value: null}, action: any) {
  switch (action.type) {
    case 'SET_TITULAR': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function bankAccountDataHolderReducer(
  state: ReduxState = {value: ''},
  action: any
) {
  switch (action.type) {
    case 'SET_BANK_ACCOUNT_DATA_HOLDER': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function updateRoutesNewSelectedPatientReducer(
  state: ReduxState = {value: 0},
  action: any
) {
  switch (action.type) {
    case 'SET_UPDATE_ROUTES_NEW_SELECTED_PATIENT': {
      return {value: state.value + 1};
    }
    default:
      return state;
  }
}

export function stringsDefaultReducer(
  state = {value: {...defaultStrings}},
  action: any
) {
  switch (action.type) {
    case 'SET_STRINGS_DEFAULT': {
      return {value: {...action.value}};
    }
    default:
      return state;
  }
}

export function productsReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_PRODUCTS': {
      return {value: {...action.value}};
    }
    default:
      return state;
  }
}

export function customerCardModalTriggerReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_CUSTOMER_CARD_MODAL_TRIGGER': {
      return {value: {...action.value}};
    }
    default:
      return state;
  }
}

export function ibanFilterOpenTriggerReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_IBAN_FILTER_OPEN_TRIGGER': {
      return {value: {...action.value}};
    }
    default:
      return state;
  }
}

export function busFunctionalitiesReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_BUS_FUNCIONALITIES': {
      return {value: action.value};
    }
    default:
      return state;
  }
}
export function busStylesReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_BUS_STYLES': {
      return {value: action.value};
    }
    default:
      return state;
  }
}
export function busProductExceptionsReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_BUS_PRODUCT_EXCEPTIONS': {
      return {value: action.value};
    }
    default:
      return state;
  }
}
export function busGroupExceptionsReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_BUS_GROUP_EXCEPTIONS': {
      return {value: action.value};
    }
    default:
      return state;
  }
}
export function buDefaultFunctionalitiesReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_BU_DEFAULT_FUNCIONALITIES': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function buDefaultStylesReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_BU_DEFAULT_STYLES': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function selectedBuReadyReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_SELECTED_BU_READY': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function consultasOnlineEnabledReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_CONSULTAS_ONLINE_ENABLED': {
      return {value: action.value};
    }
    default:
      return state;
  }
}
export function medicoOnlineEnabledReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_MEDICO_ONLINE_ENABLED': {
      return {value: action.value};
    }
    default:
      return state;
  }
}
export function isLanguageSelectedReducer(
  state: ReduxState = {value: false},
  action: any
) {
  switch (action.type) {
    case 'SET_IS_LANGUAGE_SELECTED': {
      return {value: action.value};
    }
    default:
      return state;
  }
}
export function languageReducer(
  state: ReduxState = {value: undefined},
  action: any
) {
  switch (action.type) {
    case 'SET_LANGUAGE': {
      return {value: action.value};
    }
    default:
      return state;
  }
}
export function languageOptionsReducer(
  state: ReduxState = {value: []},
  action: any
) {
  switch (action.type) {
    case 'SET_LANGUAGE_OPTIONS': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function currenciesReducer(
  state: ReduxState = {value: []},
  action: any
) {
  switch (action.type) {
    case 'SET_CURRENCIES': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function tenantReducer(state: ReduxState = {value: null}, action: any) {
  switch (action.type) {
    case 'SET_TENANT': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function accessTokenReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_ACCESS_TOKEN': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function showPersonalDateReducer(
  state: ReduxState = {value: false},
  action: any
) {
  switch (action.type) {
    case 'SET_SHOW_PERSONAL_DATE': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function disableReimbursementRequestButtonReducer(
  state: ReduxState = {value: false},
  action: any
) {
  switch (action.type) {
    case 'SET_DISABLE_REIMBURSEMENT_REQUEST_BUTTON': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function userBankAccountDataWasUpdatedReducer(
  state: ReduxState = {value: false},
  action: any
) {
  switch (action.type) {
    case 'SET_USER_BANK_ACCOUNT_DATA_WAS_UPDATED': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function isUnderMaintenanceReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_IS_UNDER_MAINTENANCE': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function isUnderMaintenanceMessageReducer(
  state: ReduxState = {value: null},
  action: any
) {
  switch (action.type) {
    case 'SET_IS_UNDER_MAINTENANCE_MESSAGE': {
      return {value: action.value};
    }
    default:
      return state;
  }
}

export function busFuncMapDefaultObjectReducer(
  state: ReduxState = {value: {}},
  action: any
) {
  switch (action.type) {
    case 'SET_BUS_FUNC_MAP_DEFAULT_OBJECT': {
      return {value: {...action.value}};
    }
    default:
      return state;
  }
}
